import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=207821c4&"
import script from "./categories.vue?vue&type=script&lang=ts&"
export * from "./categories.vue?vue&type=script&lang=ts&"
import style0 from "./categories.vue?vue&type=style&index=0&id=207821c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports